import type {
  AnalyticsEvent,
  IAnalyticsProvider,
} from "@repo/analytics/client";

type Provider = Pick<
  IAnalyticsProvider<unknown>,
  "trackEvent" | "trackPageView"
>;
type Operation = (provider: Provider) => Promise<void>;

/** Stable callbacks keep early mount events until the SDK is initialized. */
export function createAnalyticsQueue() {
  let provider: Provider | undefined;
  const pending: Operation[] = [];
  const send = (operation: Operation): Promise<void> => {
    if (provider) return operation(provider).catch(() => {});
    if (pending.length < 200) pending.push(operation);
    return Promise.resolve();
  };
  return {
    trackEvent: (event: AnalyticsEvent) =>
      send((target) => target.trackEvent(event)),
    trackPageView: (url: string) => send((target) => target.trackPageView(url)),
    attach(target: Provider) {
      provider = target;
      for (const operation of pending.splice(0)) void send(operation);
    },
  };
}
